export const TOOLTIPS_EN = Object.freeze({
  HOME: "Overview of all sites linked to this account",

  ACTIVE_SITES: "All active sites",
  INACTIVE_SITES: "Registered sites that are not commissioned",
  SITE_HEALTH: "Overview of the current status of all commissioned sites",
  USER_ACTIVITY: "All user activity on the linked sites",
  INSTALLED_BATTERY_POWER: "Total controlled battery power across all sites",
  SITE_ACTIVITY: "All site activity on the linked sites",
  CURTAILABLE_POWER: "Total controlled solar power across all sites",
  CREDIT_LINE_PER_KW: "Min-Max and average profits of all sites and top 5",
  FAVOURITE_SITES: "Favorite sites can be marked in the sites overview",
  COMMISSIONING_CARD: "Sites in commissioning requiring specific actions",

  SITE_OVERVIEW_TAB: "Table with all sites",
  NEW_SITE_BUTTON: "Create a new site",

  GENERAL_TAB: "All relevant info about the current site",
  GENERAL_INFO_CARD: "General info about the current site",
  ALERTS_CARD: "Possible alerts regarding the current site",
  OFFTAKE_CONTRACT_CARD: "Detailed info about the offtake contract",
  INJECTION_CONTRACT_CARD: "Detailed info about the injection contract",
  BOX_INFO_CARD: "Detailed info about the installed box",
  CONTROL_STATUS_CARD: "Info about active connections and active control",
  PRODUCT_INFO_CARD: "Info about the configured product",
  OVERRIDES_CARD: "Manual control override actions",
  COMMANDS_CARD: "Perform commands on the smartbox",

  ACTIVITY_CARD: "Overview of changes made on the portal",
  INSTALLATION_NOTES_CARD: "Space to keep notes about the site",

  DEVICES_TAB: "View and manage all devices connected to this site.",
  GREEN_POWER_CERTIFICATES: "Display of inverters where curtailment is applied",
  CONFIGURED: "Overview of all configured devices",
  AUTO_PROBED: "Overview of devices automatically detected by the system",
  SCAN_FOR_DEVICES_DEVICE_PROBE: "Scan for available devices",
  ARP_RESULTS: "Overview of all IP addresses found on the network",

  INSTALLATION_TAB: "Schematic layout of the entire installation",
  INSTALLATION_CARD: "Maximum consumption and injection limit taken into account by the control algorithm.",
  SCHEMATIC:
    "This schematic shows the installation layout, beginning with the grid meter as the first node, followed by all connected devices",
  LIVE_CONTROL_LOOP: "Real-time data",

  METERING_TAB: "Overview of all measured site data",
  PROFIT_IMBALANCE: "Gross revenue / Display of Epex prices vs imbalance prices",
  DEVICE_METERING: "Measurements and controls present on the site",
  FORECAST_NETWORK_OPERATOR:
    "Forecast and actual consumption/injection - Grid meter + measurement by network operator (these should ideally align)",
  STATISTICS: "Overview of all useful statistics and info related to the installation",

  LOG_TAB: "Display of all activities",
  JOURNALCTL: "Box logs",
  ACTIVITY_LOG: "Overview of changes made on the platform",

  COMMISSIONING_TAB: "Allows commissioning of each device",
  DEVICE_COMMISSIONING_OVERVIEW: "Commissioning status of each device in the schematic",
  GRID_METER: "Current and historical grid measurements and ability to confirm that the measurement is OK",
  METERS: "Current and historical measurements of additional meters and ability to confirm they are OK",
  BATTERIES: "Current and historical measurements of all available batteries and ability to confirm they are OK",
  SOLAR_INVERTERS:
    "Current and historical measurements of all available solar inverters and ability to confirm they are OK",
  FINAL_VERIFICATION: "Final commissioning of all devices",
  DASHBOARD: "Link to Elion customer dashboard",
  COMMISSIONING_DENIED_CARD: "Reason why this procedure was rejected",

  INSUFFICIENT_RIGHTS_TO_EDIT: "No rights to make edit",

  UPDATES_BLOCKED_DURING_COMMISSIONING: "No updates allowed while a commissioning procedure is ongoing",
  UPDATES_BLOCKED_SITE_OFFLINE: "No updates allowed while the site is inactive",
});
